export default [
    {
        path: 'cajas',
        name: 'pos.cajas',
        component: () => import('@/views/pos/caja/CajaSeleccionar.vue'),

    },
    {
    path: 'iniciarCaja',
    name: 'pos.iniciarCaja',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/caja/caja.iniciar.vue'),

  },
  {
    path: 'cerrarCaja',
    name: 'pos.cerrarCaja',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/caja/caja.finalizar.vue'),

  },
  {
    path: 'movimientos',
    name: 'pos.movimientos',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/caja/CajaMovimientos.vue'),


  },
  {
    path: 'movimientos/retiro',
    name: 'pos.movimientosRetiro',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/pos/caja/CajaRetiroEfectivo.vue'),


  },


];
